import React, {useMemo}								from 'react';
import {Route, Routes, useParams}					from 'react-router-dom';
import moment										from 'moment';

import Header										from '../Header/Header';
import Contracts									from './Contracts';
import ContractAdd									from './ContractsAdd';

import {useAppSelector}								from '../app/hooks';

import LANGUAGE										from '../ressources/language';

import './Contracts.css';

interface MainContractsProps {
	notifContract: boolean
}


function MainContracts(props: MainContractsProps) {
	const contracts = useAppSelector(state => state.contracts.data);
	const contractsNotValala = useAppSelector(state => state.contractsNotValala.data);
	const lang = useAppSelector(state => state.settings.lang);

	const activeContractCount = useMemo(() => {
		let count = 0;

		contracts.forEach((contract) => {
			for (let i = 0; contract.funderList[i]; i++)
				count += contract.funderList[i].dateEnd ? 0 : 1;
		});

		contractsNotValala.forEach((contract) => {
			if (contract.locationEnd && moment(contract.locationEnd).isAfter(moment()))
				count++;
		});

		return count;
	}, [contracts]);

	const params = useParams();
	const TEXTE = LANGUAGE(lang);
	const MENU_DATA = [
		{
			value:  '',
			render: (
				<span style={{gap: 2}}>
					{TEXTE.header.contract.contracts}
					{props.notifContract && <div className={'headerNotif'} />}
				</span>
			)
		},
		{
			value:          'add',
			render:         TEXTE.header.contract.add,
			minimizeHeader: TEXTE.header.contract.minimize
		}
	];

	return (
		<div className={'globalContainerWithHeader'}>
			<Header
				menu={MENU_DATA}
				menuValue={params['*']}
				title={TEXTE.contract.title}
				badgeText={`${activeContractCount} ${TEXTE.contract.current}`}
			/>

			<Routes>
				<Route path={'/'} element={<Contracts />} />
				<Route path={'/add'} element={<ContractAdd />} />
				<Route path={'/:idContract'} element={<Contracts />} />
				<Route path={'/:idContract/:indexFunder'} element={<Contracts />} />
			</Routes>
		</div>
	);
}

export default MainContracts;
